/*
 * @Author: dali
 * @Date: 2022-09-26 16:56:30
 * @LastEditors: dali crayoncrook@gmail.com
 * @LastEditTime: 2026-01-05 10:37:51
 * @FilePath: \gerlun-react-website\src\route\index.js
 * @Description:
 */
import Home from '@/pages/home'
import PreOrder from '@/pages/mobile/pre-order'
import Register from '@/pages/mobile/register'
import RegisterSuccess from '@/pages/mobile/register/success'
import Information from '@/pages/information'
import ListParticulars from '@/pages/information/inform-particulars'
import HomePage from '@/pages/homePage'
import Apply from '@/pages/solution/apply'
import Appreciation from '@/pages/solution/appreciation'
import Bill from '@/pages/solution/bill'
import Operation from '@/pages/solution/operation'
import Wealth from '@/pages/solution/wealth'
import AboutUs from '@/pages/about-us/index.jsx'
import Case from '@/pages/case/index.jsx'
import CaseDtl from '@/pages/case/particulars/index.jsx'
import Serve from '@/pages/product-center/serve'
import Standard from '@/pages/product-center/standard'
import EraAccount from '@/pages/product-center/era-account'
import Popularize from '@/pages/product-center/popularize'
import Advanced from '@/pages/product-center/advanced'
import AdvancedEra from '@/pages/product-center/advanced-era'
import Cloud from '@/pages/product-center/cloud'
import ProductChoose from '@/pages/product-choose'
import VideoCenter from '@/pages/video-center/index.jsx'
import VideoDetail from '@/pages/video-center/video-detail/index.jsx'
import SmallLoan from '@/pages/small-loan/index.jsx'
import SmallLoanDetail from '@/pages/small-loan/detail/index.jsx'

export const routes = [
  {
    path: '/',
    element: <Home />,
    children: [
      { index: true, element: <HomePage /> },
      {
        path: '/sol-apply',
        element: <Apply />
      },
      {
        path: '/sol-appreciation',
        element: <Appreciation />
      },
      {
        path: '/sol-bill',
        element: <Bill />
      },
      {
        path: '/sol-operation',
        element: <Operation />
      },
      {
        path: '/sol-wealth',
        element: <Wealth />
      },
      {
        path: '/aboutus',
        element: <AboutUs />
      },
      {
        path: '/case',
        element: <Case />
      },
      {
        path: ':case-dtl/:id',
        element: <CaseDtl />
      },
      {
        path: '/info',
        element: <Information />
      },
      {
        path: '/ListParticulars/:id',
        element: <ListParticulars />
      },
      {
        path: '/serve',
        element: <Serve />
      },
      {
        path: '/standard/:id',
        element: <Standard />
      },
      {
        path: '/era-account',
        element: <EraAccount />
      },
      {
        path: '/product-detail/:productKey',
        element: <EraAccount />
      },
      {
        path: '/popularize',
        element: <Popularize />
      },
      {
        path: '/advanced',
        element: <Advanced />
      },
      {
        path: '/advanced-era',
        element: <AdvancedEra />
      },
      {
        path: '/cloud',
        element: <Cloud />
      },
      {
        path: '/product-choose',
        element: <ProductChoose />
      },
      {
        path: '/video-center',
        element: <VideoCenter />
      },
      {
        path: '/video-detail/:id/:aid',
        element: <VideoDetail />
      },
      {
        path: '/small-loan',
        element: <SmallLoan />
      },
      {
        path: '/small-loan/detail/:id',
        element: <SmallLoanDetail />
      }
    ]
  },
  {
    path: '/preOrder',
    element: <PreOrder />
  },
  {
    path: '/register',
    element: <Register />
  },
  {
    path: '/register-success',
    element: <RegisterSuccess />
  }
]
